import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("RodgersPC Command Center root element was not found.");
}

/*
 * StrictMode intentionally disabled.
 *
 * React StrictMode double-runs effects in development builds.
 * RodgersPC Command Center performs real session, Firestore, Drive tree,
 * Drive warmup, auth, token, export, and workspace restore effects.
 *
 * Keeping StrictMode off prevents duplicate Drive loads, duplicate state restores,
 * duplicate Google auth callbacks, duplicate upload/Drive refresh calls, duplicate
 * chat restore events, and false persistence/auth issues during builder/dev preview.
 */
createRoot(rootElement).render(<App />);
